import {useState, useEffect, useRef, useContext} from "react";
import React from "react";
import {meter, meterReading, user, workOrder} from "../../../api";
import { toast } from "react-toastify";
import Select, { StylesConfig } from "react-select";
import {
    dateFormat,
    downloadPDF,
    generateLocationToArray,
    getFileUrl,
    getRequestStatusColor,
    getStatusColor,
    printLocation,
    renderImage,
} from "../../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";
import LoadingIndicator from "../../../components/LoadingIndicator";
import NormalInput from "../../../components/form/HorizontalNormalInput";
import NormalSelect from "../../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader, CardFooter } from "../../../components/card/card";
import { MachineElement } from "../../../components/MachineElement";
import ImageViewer from "../../../components/ImageViewer";
import { addDays, addMonths, addWeeks, addYears, format } from "date-fns";
import { data } from "jquery";
import Dropdown from "react-bootstrap/Dropdown";
import { TaskAction } from "../../../components/TaskAction";
import { useReactToPrint } from "react-to-print";
import TimeTracking from "../../../components/TimeTracking";
import AdditionalCost from "../../../components/AdditionalCost";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import {AppSettings} from "../../../config/app-settings";

function WorkOrderDetail({ isRequest = true }) {
    const { id } = useParams();
    const editMode = !!id;
    const context = useContext(AppSettings);
    useEffect(() => {
        context.setAppHeaderNone(true);
        context.setAppSidebarNone(true);
        context.setAppContentClass("p-0");
        return function cleanUp() {
            context.setAppHeaderNone(false);
            context.setAppSidebarNone(false);
            context.setAppContentNone(false);
            context.setAppContentClass("");
        };

        // eslint-disable-next-line
    }, []);
    const {config, getLocationName} = useAuth();
    const colourStyles = {
        control: (styles) => ({
            ...styles,
            backgroundColor: "rgba(0, 0, 0, 0.48)",
            borderColor: "var(--bs-border-color)",
        }),
        input: (styles) => ({
            ...styles,
            color: "white",
        }),
        menu: (styles) => ({
            ...styles,
            color: "grey",
        }),
    };

    // Helper functions to calculate totals
    const calculateTimeTrackingTotal = (timeEntries) => {
        if (!timeEntries || !Array.isArray(timeEntries)) return 0;

        return timeEntries.reduce((total, entry) => {
            const hours = parseFloat(entry.hours) || 0;
            const minutes = parseFloat(entry.minutes) || 0;
            const hourlyRate = parseFloat(entry.hourly_rate) || 0;

            // Convert minutes to hours and add to total hours
            const totalHours = hours + (minutes / 60);

            // Calculate cost for this entry
            const entryCost = totalHours * hourlyRate;

            return total + entryCost;
        }, 0);
    };

    const calculateAdditionalCostTotal = (additionalCosts) => {
        if (!additionalCosts || !Array.isArray(additionalCosts)) return 0;

        return additionalCosts.reduce((total, cost) => {
            const costAmount = parseFloat(cost.cost) || 0;
            return total + costAmount;
        }, 0);
    };
    const [signatureConfirmation, setSignatureConfirmation] = useState(false);
    const [status, setStatus] = useState("");
    const [options, setOptions] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [locations, setLocations] = useState([]);
    const [users, setUsers] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [attachmentsRequest, setAttachmentsRequest] = useState([]);
    const [choosenSignature, setChoosenSignature] = useState([]);
    const [tempStatus, setTempStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [assignType, setAssignType] = useState("individual");
    const [newReading, setNewReading] = useState({
        reading_value: "",
        reading_date: "",
        notes: "",
    });
    const [dataToSend, setDataToSend] = useState({
        asset_id: "",
        start_date: "",
        due_date: "",
        status: "",
        description: "",
        title: "",
        fault: "",
        recurring_wo: "",
        priority: "medium",
        assigned_to: "",
        team_id: "",
        vendor_id: "",
        category_id: "",
        request_tasks: [],
        work_order_tasks: [],
        inventories: [],
        meter_reading_id: "",
    });
    const navigate = useNavigate();
    function backToList() {
        navigate(-1);
    }
    const handleSignatureConfirmation = async () => {
        if (dataToSend.meter_reading_id) {
            if(!newReading.reading_value){
                toast.error("Please fill in the meter reading value");
                return;
            }
            const result = await meterReading.update(dataToSend.meter_reading_id, {
                reading_value: newReading.reading_value,
                reading_date: newReading.reading_date,
                notes: newReading.notes,
            });
            if (result.ok) {
                toast.success("Meter Reading updated");
            }
        }

        const result = await workOrder.updateStatus(id, { status: tempStatus, signature: choosenSignature.map(i => i.value), ...newReading });
        if (result.ok) {
            toast.success("Status updated");
        } else {
            toast.error("Status failed to update");
        }
        setStatus(tempStatus)
        setSignatureConfirmation(false)
        getRecord();
    }

    async function getMasterData() {
        setIsLoading(true);
        try {
            if (editMode) {
                await getRecord();
            }
        } catch (err) {
        } finally {
            setIsLoading(false);
        }
    }



    useEffect(() => {
        getMasterData();
    }, [id]);

    async function getRecord() {
        const result = await workOrder.getOneByToken(id);

        if (result.ok) {
            const body = await result.json();
            let data = body.data;

            const defaultValue = {
                asset_id: data.asset_id,
                start_date: format(new Date(data.start_date), "yyyy-MM-dd"),
                due_date: format(new Date(data.due_date), "yyyy-MM-dd"),
                created_at: format(new Date(data.created_at), "yyyy-MM-dd"),
                status: data.status,
                description: data.description,
                title: data.title,
                fault: data.fault,
                recurring_wo: data.recurring_wo,
                signature: data.WorkOrderSignature,
                priority: data.priority,
                asset_component: data.asset_component?.component,
                assigned_to: data.assigned_to,
                team_id: data.team_id || "",
                vendor_id: data.vendor_id,
                category: data.category?.name,
                tasks:data.tasks,
                request_status:data.request_status,
                vendor: data.vendor?.vendor_name,
                assigned: data.team_id
                    ? data.team?.team_name
                    : data.assigned_to_user?.firstname,
                assignType: data.team_id ? "Team" : "Individual",
                asset: data.asset?.asset_name,
                request_tasks: data.tasks.filter((t) => t.is_request) || [],
                work_order_tasks: data.tasks.filter((t) => !t.is_request) || [],
                inventories: data.inventories || [],
                request_document: data.request_document,
                time_entries: data.time_entries || [],
                additional_costs: data.additional_costs || [],
                meter_reading_id: data.meter_reading_id,
                meter_reading: data.meter_reading,
                number: data.number,
            };


            if(data.asset?.location) {
                const locationName = [];
                function generateLocation(location) {
                    locationName.push(location.location_name);
                    if (location.parent_location) {
                        generateLocation(location.parent_location);
                    }
                }

                generateLocation(data.asset.location);
                setLocations(locationName.reverse());
            }else if(data.location) {
                const locationName = [];
                function generateLocation(location) {
                    locationName.push(location.location_name);
                    if (location.parent_location) {
                        generateLocation(location.parent_location);
                    }
                }
                generateLocation(data.location);
                setLocations(locationName.reverse());
            }


            if(defaultValue.meter_reading){
                setNewReading({
                    reading_value: data.meter_reading.reading_value,
                    notes: data.meter_reading.notes,
                    reading_date:format(new Date(data.start_date), "yyyy-MM-dd"),
                });
            }




            if (defaultValue.request_tasks.length > 0) {

                defaultValue.request_tasks.forEach((task) => {
                    if (task.task_photo)
                        task.url_full = renderImage(
                            `machine/attachment/${task.task_photo}`
                        );
                });
            }



            if (defaultValue.work_order_tasks.length > 0) {
                defaultValue.work_order_tasks.forEach((task) => {
                    if (task.task_photo)
                        task.url_full = renderImage(
                            `machine/attachment/${task.task_photo}`
                        );
                });
            }

            if (data.attachments) {
                // check if data.attachments is an object
                if (typeof data.attachments !== "object") {
                    console.error("attachments is not an object");
                    return;
                }
                const att = [];
                const attReq = [];
                if (data.attachments)
                    Object.keys(data.attachments).forEach((key) => {
                        if (data.attachments[key]) {
                            const name = key.split("_")[3];
                            const type = key.split("_")[2];
                            const isRequest = key.split("_")[0] !== "workoder";
                            const url = renderImage(
                                `machine/attachment/${data.attachments[key]}`
                            );
                            const attachment = {
                                name: name,
                                type,
                                url,
                                value: data.attachments[key],
                            };
                            att.push(attachment);
                            // if (!isRequest) {
                            //
                            // }else{
                            //   attReq.push(attachment)
                            // }
                        }
                    });
                setAttachments(att);
                setAttachmentsRequest(attReq);
            }
            setOptions(
                isRequest
                    ? ["Pending", "Approved", "Declined"]
                    : ["Open", "In Progress", "On Hold", "Completed"]
            );
            setStatus(isRequest ? data.request_status : data.status);
            setDataToSend(defaultValue);
        }
    }

    const handleChangeStatus = async (v) => {
        try {
            let result;
            console.log({v})
            setIsLoading(true)
            if (isRequest) {
                result = await workOrder.updateRequestStatus(id, { status: v });
                if (result.ok) {
                    toast.success("Status updated");
                } else {
                    toast.error("Status failed to update");
                }
                setStatus(v);

                getRecord();
            } else {
                if (v === "Completed") {
                    setSignatureConfirmation(true)
                    setTempStatus(v)
                }else{
                    result = await workOrder.updateStatus(id, { status: v });
                    if (result.ok) {
                        toast.success("Status updated");
                    } else {
                        toast.error("Status failed to update");
                    }
                    setStatus(v);

                    getRecord();
                }
            }
            setIsLoading(false)

        } catch (e) {
            toast.error(e.message);
        }

    };
    const componentRef = useRef();
    const downloadHandler = useReactToPrint({
        content: () => componentRef.current,
    });

    const generateUpcomingWorkOrder = (recurring_wo) => {

        const recurrenceMap = {
            daily: (date) => addDays(date, 1),
            weekly: (date) => addWeeks(date, 1),
            monthly: (date) => addMonths(date, 1),
            "3months": (date) => addMonths(date, 3),
            "6months": (date) => addMonths(date, 6),
            yearly: (date) => addYears(date, 1),
        };

        const nextDate = recurrenceMap[recurring_wo](new Date(dataToSend.start_date));
        return format(nextDate, "yyyy-MM-dd");
    }

    return (
        <Card className={"form-darker"}>

            <LoadingIndicator open={isLoading} />
            <ConfirmationDlg
                open={signatureConfirmation}
                title="Signature Confirmation"
                description="Are you sure you want to confirm the signature?"
                btnCancelText="Cancel"
                btnSubmitText="Confirm"
                onSubmit={handleSignatureConfirmation}
                onClose={() => setSignatureConfirmation(false)}
            >
                <div>
                    <label className="form-label">Signature Completion By</label>
                    <Select
                        isMulti
                        styles={colourStyles}
                        options={users.map((i) => {
                            return {
                                value: i.username,
                                label: i.firstname + " " + i.lastname,
                            };
                        })}
                        value={choosenSignature}
                        onChange={(e) => {
                            setChoosenSignature(e);
                        }}
                    />
                </div>
            </ConfirmationDlg>


            <CardBody>
                <div className="row g-1 mb-3 d-flex justify-content-end ">
                    <div className="w-25">

                    </div>
                </div>

                {/* <div className="row g-1 mb-3 d-flex justify-content-end">

                            <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Dropdown button
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">




                    </div>
</div>

          </div> */}
                <div id="download-preview " className={"dark-print container p-5"} ref={componentRef}>
                    <div className="row g-3">
                        {dataToSend.status === "Completed" && (<div className="col-md-12">
                            <Card className="mb-3 ">
                                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400 ">
                                    <div className="d-flex align-items-center">
                                        Work Order Completion Signature By
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div className="d-flex justify-content-center align-items-center">
                                        {dataToSend.signature.length ? (
                                            <div className="d-flex  align-items-center">
                                                {dataToSend.signature.map((data) =>
                                                    (
                                                        <Card key={data.id} className="mb-3 border-theme mx-2">

                                                            <CardBody style={{
                                                                textAlign: "center", width: "180px",
                                                                height: "140px",
                                                            }}>

                                                                <div className="mb-2">
                                                                    {data.user.signature ? <img
                                                                        src={getFileUrl(data.user.signature)}
                                                                        alt="Signature"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth: "200px",
                                                                            maxHeight: "100px",
                                                                            filter: "invert(1)",
                                                                        }}
                                                                    /> : (
                                                                        <div

                                                                            className={
                                                                                "signature   align-items-center p-3 mb-2"
                                                                            }
                                                                        >
                                                                            {data.user ? data.user.firstname + " " + data.user.lastname : "No User"}
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </CardBody>
                                                            <CardFooter
                                                                className="d-flex align-items-center bg-theme bg-opacity-10 fw-400 ">
                                                                <div className="d-flex align-items-center">
                                                                    {data.user ? data.user.firstname + " " + data.user.lastname : "No User"}
                                                                </div>
                                                            </CardFooter>
                                                        </Card>
                                                    )
                                                )}

                                            </div>
                                        ) : (
                                            <div className="text-muted">
                                                No signature available
                                            </div>
                                        )}
                                    </div>
                                </CardBody>
                            </Card>
                        </div>)}


                    </div>
                    <div className="row g-3" style={{color: "black"}}>
                        <h4>
                            Request Detail
                        </h4>
                        <div className="col-md-12" style={{background:"white"}}>
                            <div className="grid-report">
                                <label htmlFor="workOrderTitle">
                                    {isRequest ? "Request" : "Work Order Title"}
                                </label>
                                <div>
                                    {dataToSend["title"]}
                                </div>
                            </div>
                            <div className="grid-report">
                                <label htmlFor="workOrderTitle">
                                    Request Status
                                </label>
                                <div>
                                    {dataToSend["request_status"]}
                                </div>
                            </div>
                            <div className="grid-report">
                                <label htmlFor="workOrderTitle">
                                    Work Order Status
                                </label>
                                <div>
                                    {dataToSend["status"]}
                                </div>
                            </div>

                            <div className="grid-report ">
                                <label htmlFor="startDate">
                                    Created Date
                                </label>
                                <div>
                                    {dataToSend["created_at"]}
                                </div>
                            </div>

                            <div className="grid-report">
                                <label htmlFor="startDate">
                                    Start Date
                                </label>

                                <div>
                                    {dataToSend["start_date"]}
                                </div>
                            </div>

                            <div className="grid-report">
                                <label htmlFor="dueDate">
                                    Due Date
                                </label>

                                <div>
                                    {dataToSend["due_date"]}
                                </div>

                            </div>

                            <div className="grid-report">
                                <label htmlFor="recurringWO">
                                    Recurring WO
                                </label>

                                <div>
                                    {dataToSend["recurring_wo"] || "No"}
                                </div>

                            </div>
                            <div className="grid-report">
                                <label htmlFor="description">
                                    Description<span className="text-danger">*</span>
                                </label>

                                <div>
                                    {dataToSend["description"]}
                                </div>

                            </div>
                            <div className="grid-report">
                                <label htmlFor="asset">
                                    Asset<span className="text-danger">*</span>
                                </label>

                                <div>
                                    {dataToSend["asset"]}
                                </div>

                            </div>
                            {dataToSend.asset_component ? (
                                <div className="grid-report">
                                    <label htmlFor="asset">
                                        Sub-Asset / Asset Component
                                        <span className="text-danger">*</span>
                                    </label>

                                    <div>
                                        {dataToSend["asset_component"]}
                                    </div>
                                </div>
                            ) : null}
                            <div className="grid-report">
                                <label htmlFor="priority">
                                    Priority
                                </label>

                                <div>
                                    {dataToSend["priority"]}
                                </div>
                            </div>
                            <div className="grid-report">
                                <label htmlFor="priority">
                                    Category
                                </label>
                                <div>
                                    {dataToSend["category"]}
                                </div>
                            </div>
                            <div className="grid-report">
                                <label htmlFor="priority">
                                    Fault / Suspected Issue
                                </label>

                                <div>
                                    {dataToSend["fault"]}
                                </div>
                            </div>
                        </div>
                        {dataToSend.status === "Completed" ? (
                            <div className="col-md-12">
                                <Card className="mb-3 ">
                                    <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400 ">
                                        <div
                                            className="d-flex align-items-center"
                                            style={{color: "black"}}
                                        >
                                            Work Order Completion Signature By
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <div className="d-flex justify-content-center align-items-center">
                                            {dataToSend.signature.length ? (
                                                <div className="d-flex  align-items-center">
                                                    {dataToSend.signature.map((data) => (
                                                        <Card
                                                            key={data.id}
                                                            className="mb-3 border-theme mx-2"
                                                        >
                                                            <CardBody
                                                                style={{
                                                                    textAlign: "center",
                                                                    width: "180px",
                                                                    height: "140px",
                                                                }}
                                                            >
                                                                <div className="mb-2">
                                                                    {data.user.signature ? (
                                                                        <img
                                                                            src={getFileUrl(data.user.signature)}
                                                                            alt="Signature"
                                                                            className="img-fluid"
                                                                            style={{
                                                                                maxWidth: "200px",
                                                                                maxHeight: "100px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <div
                                                                            style={{color: "black"}}
                                                                            className={
                                                                                "signature   align-items-center p-3 mb-2"
                                                                            }
                                                                        >
                                                                            {data.user
                                                                                ? data.user.firstname +
                                                                                " " +
                                                                                data.user.lastname
                                                                                : "No User"}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </CardBody>
                                                            <CardFooter
                                                                className="d-flex align-items-center bg-theme bg-opacity-10 fw-400 ">
                                                                <div className="d-flex align-items-center"
                                                                     style={{color: "black"}}>
                                                                    {data.user
                                                                        ? data.user.firstname +
                                                                        " " +
                                                                        data.user.lastname
                                                                        : "No User"}
                                                                </div>
                                                            </CardFooter>
                                                        </Card>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="text-muted">No signature available</div>
                                            )}
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        ) : null}

                    </div>
                    {attachments.length > 0 && (
                        <div className="mb-3">
                            <Card>
                                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                                    Attachments
                                </CardHeader>
                                <CardBody>
                                    <div className="row">
                                        {attachments.map((attachment, index) => (
                                            <div key={index} className={"col-sm-4 position-relative"}>
                                                {attachment.type === "image" && (
                                                    <ImageViewer
                                                        staticImage={attachment.url}
                                                        className={"img-fluid w-100"}
                                                        alt=""
                                                    />
                                                )}
                                                {attachment.type === "video" && (
                                                    <video
                                                        src={attachment.url}
                                                        className={"img-fluid w-100"}
                                                        width={"100%"}
                                                        controls
                                                    />
                                                )}
                                                {attachment.type === "pdf" && (
                                                    <iframe
                                                        src={attachment.url}
                                                        className={" w-100"}
                                                        width={"100%"}
                                                        height={"350px"}
                                                    />
                                                )}
                                                {attachment.type === "other" && (
                                                    <a
                                                        href={attachment.url}
                                                        target={"_blank"}
                                                        rel="noreferrer"
                                                        style={{
                                                            height: "200px",
                                                            paddingTop: "95px",
                                                            display: "block",
                                                        }}
                                                        className={
                                                            "border-theme border-1 border w-100 text-center"
                                                        }
                                                    >
                                                        Download the File
                                                    </a>
                                                )}

                                                <div className="my-2">
                                                    <input
                                                        type="text"
                                                        className={"form-control"}
                                                        value={attachment.name}
                                                        readOnly
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    )}

                    {
                        !isRequest && dataToSend.meter_reading_id && (
                            <div className="mt-2">
                                <Card>
                                    <CardHeader>Meter Reading</CardHeader>
                                    <CardBody>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <NormalInput
                                                    required={true}
                                                    value={newReading.reading_value}
                                                    label="Reading Value"
                                                    onchange={(e) => setNewReading({
                                                        ...newReading,
                                                        reading_value: e.target.value
                                                    })}
                                                    name="reading_value"
                                                    type="number"
                                                    placeholder={`Enter reading in ${dataToSend.meter?.unit}`}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <NormalInput
                                                    required={true}
                                                    value={newReading.reading_date}
                                                    label="Reading Date"
                                                    onchange={(e) => setNewReading({
                                                        ...newReading,
                                                        reading_date: e.target.value
                                                    })}
                                                    name="reading_date"
                                                    type="date"
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <NormalTextArea
                                                    value={newReading.notes}
                                                    label="Notes"
                                                    onchange={(e) => setNewReading({...newReading, notes: e.target.value})}
                                                    name="notes"
                                                    rows={3}
                                                    placeholder="Optional notes about this reading"
                                                />
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        )
                    }


                    {!isRequest && (
                        <>


                            {
                                dataToSend["request_tasks"].length > 0 && (<div className="mt-2">
                                    <TaskAction title="Request Task List" onChange={() => {
                                    }} value={dataToSend["request_tasks"]}/>
                                </div>)
                            }


                            <div className="mt-2">
                                <TaskAction title="Work Order Task List" onChange={() => {
                                }} value={dataToSend["work_order_tasks"]}/>
                            </div>
                        </>
                    )}

                    {!isRequest && (
                        <div className="mt-2">
                            <TimeTracking
                                value={dataToSend["time_entries"]}
                                onChange={(v) => {
                                }}
                                workOrderId={id}
                                readonly
                            />
                        </div>
                    )}

                    {!isRequest && (
                        <div className="mt-2">
                            <AdditionalCost
                                value={dataToSend["additional_costs"]}
                                onChange={(v) => {
                                }}
                                readonly
                            />
                        </div>
                    )}

                    {!isRequest && (
                        <div className="mt-2">
                            <Card>
                                <CardHeader>Total Cost Summary</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span className="fw-bold">Time Tracking Total:</span>
                                                <span className="text-success fw-bold">
                          {config?.currency_symbol} {calculateTimeTrackingTotal(dataToSend["time_entries"]).toFixed(2)}
                        </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span className="fw-bold">Additional Cost Total:</span>
                                                <span className="text-success fw-bold">
                          {config?.currency_symbol} {calculateAdditionalCostTotal(dataToSend["additional_costs"]).toFixed(2)}
                        </span>
                                            </div>
                                            <hr/>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="fw-bold fs-5">Grand Total:</span>
                                                <span className="text-primary fw-bold fs-5">
                          {config?.currency_symbol} {(calculateTimeTrackingTotal(dataToSend["time_entries"]) + calculateAdditionalCostTotal(dataToSend["additional_costs"])).toFixed(2)}
                        </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="text-muted small">
                                                <div>• Time tracking includes labor hours and rates</div>
                                                <div>• Additional costs include materials and other expenses</div>
                                                <div>• All costs are calculated in {config?.currency_symbol}</div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
}

export default WorkOrderDetail;
